<tt-page>
    <tt-page-heading [ttModel]="'p2_m_dodataimps'" ttTranslate></tt-page-heading>
    <tt-grid *ngIf="!!grid" class="p-2 flex-1" [(ttOptions)]="grid"></tt-grid>
</tt-page>
